"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STANDARD_TRANSITION_CONFIG = exports.GRID_ANIMATION_VARIANTS = exports.MotionIconButton = exports.MotionButton = exports.MotionText = exports.MotionImage = exports.MotionFlex = exports.MotionBox = exports.MotionGridItem = exports.MotionGrid = void 0;
const react_1 = require("@chakra-ui/react");
const framer_motion_1 = require("framer-motion");
exports.MotionGrid = (0, framer_motion_1.motion)(react_1.Grid);
exports.MotionGridItem = (0, framer_motion_1.motion)(react_1.GridItem);
exports.MotionBox = (0, framer_motion_1.motion)(react_1.Box);
exports.MotionFlex = (0, framer_motion_1.motion)(react_1.Flex);
exports.MotionImage = (0, framer_motion_1.motion)(react_1.Image);
exports.MotionText = (0, framer_motion_1.motion)(react_1.Text);
exports.MotionButton = (0, framer_motion_1.motion)(react_1.Button);
exports.MotionIconButton = (0, framer_motion_1.motion)(react_1.IconButton);
exports.GRID_ANIMATION_VARIANTS = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: {
            staggerChildren: 0.5,
            delayChildren: 0,
            ease: 'easeOut',
            duration: 0.7,
        },
    },
};
exports.STANDARD_TRANSITION_CONFIG = {
    ease: 'easeInOut',
    duration: 1,
};
//# sourceMappingURL=animation.js.map